interface RuntimeConfig {
  apiBaseUrl?: string;
  sentryDsn?: string;
}
declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

const rt = window.__APP_CONFIG__ ?? {};

export const config = {
  // '' = same-origin (dev Vite proxy handles /api). Runtime shim wins over build-time.
  apiBaseUrl: rt.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || '',
  sentryDsn: rt.sentryDsn || import.meta.env.VITE_SENTRY_DSN || '',
};
